export enum ColumnType {
  isActive = "isActive",
  name = "name",
  householdMembersCount = "householdMembersCount",
  enableTime = "enableTime",
  previousWaste = "previousWaste",
  currentWaste = "currentWaste",
  amount = "amount",
  depositAmount = "depositAmount",
  realAmount = "realAmount",
  balance = "balance",
  isPaid = "isPaid",
}

export const columnLabelsCalculation: ColumnType[] = [
  ColumnType.isActive,
  ColumnType.name,
  ColumnType.householdMembersCount,
  ColumnType.enableTime,
  ColumnType.previousWaste,
  ColumnType.amount,
];

export const columnLabelsBilling: ColumnType[] = [
  ColumnType.isActive,
  ColumnType.name,
  ColumnType.householdMembersCount,
  ColumnType.enableTime,
  ColumnType.currentWaste,
  ColumnType.depositAmount,
  ColumnType.realAmount,
  ColumnType.balance,
  ColumnType.isPaid,
];
